'use client';

import 'client-only';

import { ToolsAppLinkFeature } from '../common/features/tools-app-link-feature';
import { createUseFlag } from './create-use-flag';

export const useToolsAppLinkFeature = createUseFlag(ToolsAppLinkFeature);
